import useSWR from "swr";
import { ServicesURL } from "@utils/utilsApi";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";

export interface SkillOption {
  value: number;
  label: string;
}

const mapOptions = (data: any): SkillOption[] => {
  const list: any[] = Array.isArray(data) ? data : data?.output || [];
  return list.map((el) => ({
    value: el.id,
    label: el.name || el.description || String(el.id),
  }));
};

export const useSkillOptions = (
  corporateId: string,
  industryId: number | null,
  professionId: number | null,
) => {
  const industriesUrl = corporateId
    ? `${ServicesURL.getIndustries}?corporateId=${corporateId}`
    : null;

  const professionsUrl =
    corporateId && industryId
      ? `${ServicesURL.getProfessions.replace(
          ":idCorporate",
          corporateId,
        )}?industries=${industryId}`
      : null;

  const jobsUrl =
    corporateId && professionId
      ? ServicesURL.getJobs
          .replace(":idCorporate", corporateId)
          .replace(":idProfession", String(professionId))
      : null;

  const { data: industriesData } = useSWR(industriesUrl, (url: string) =>
    fetcher(url, MethodType.GET),
  );
  const { data: professionsData } = useSWR(professionsUrl, (url: string) =>
    fetcher(url, MethodType.GET),
  );
  const { data: jobsData } = useSWR(jobsUrl, (url: string) =>
    fetcher(url, MethodType.GET),
  );

  return {
    industries: mapOptions(industriesData),
    professions: mapOptions(professionsData),
    jobs: mapOptions(jobsData),
  };
};
